// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type EventKindCoverageFreq = (typeof EventKindCoverageFreq)[keyof typeof EventKindCoverageFreq];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventKindCoverageFreq = {
  monthly: 'monthly',
  weekly: 'weekly',
} as const;
